import React, { ReactElement, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { Modal, ModalProps } from '@arco-design/web-react';

export const useModal = (
    content: ReactElement,
    modalProps: ModalProps = {
        maskClosable: false,
        escToExit: false,
        simple: true,
        footer: null,
    },
) => {
    let root: ReactDOM.Root | null;
    let div: HTMLDivElement | null;
    const ref = useRef<{ onOk: () => Promise<boolean> } | null>(null);

    function render(modalProps: ModalProps, slotProps?: any) {
        const dom = (
            <Modal {...modalProps} onCancel={onCancel} afterClose={destroy} onOk={onOk}>
                {React.Children.map(content, child =>
                    React.cloneElement(child, { ...slotProps, ref, close: onCancel }),
                )}
            </Modal>
        );
        if (root) {
            root.render(dom);
        } else {
            root = ReactDOM.createRoot(div!);
            root.render(dom);
        }
    }

    async function onOk() {
        try {
            await ref.current?.onOk();
            onCancel();
        } catch (e) {}
    }

    function destroy() {
        setTimeout(() => {
            root?.unmount?.();
            root = null;
            if (div?.parentNode) {
                div.parentNode.removeChild(div);
                div = null;
            }
        });
    }

    function open(slotProps?: any) {
        div = document.createElement('div');
        document.body.appendChild(div);
        render({ visible: true, ...modalProps }, slotProps);
    }

    function onCancel() {
        render({ visible: false, ...modalProps });
    }

    return {
        open,
        close: onCancel,
    };
};
export default useModal;
